module.exports = __webpack_public_path__ + "img/logo.2938db6e.png";